import { render, staticRenderFns } from "./UpperSidebar.vue?vue&type=template&id=0c709ece&scoped=true&"
import script from "./UpperSidebar.vue?vue&type=script&lang=js&"
export * from "./UpperSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c709ece",
  null
  
)

export default component.exports